module.exports = __webpack_public_path__ + "img/tariff-change-arrow.70c80c0e.svg";